export default __webpack_public_path__ + "static/media/plusSignRight.bd2eb71a.svg";